/**
 * Plans offered at sign-up, from docs/02-product-pricing.md §4. GBP, ex VAT.
 * Keep in step with site/src/data/pricing.ts (the marketing site's pricing page).
 */
export type SignupPlanId = "trial" | "hobby" | "pro" | "business";

export interface SignupPlan {
  id: SignupPlanId;
  name: string;
  /** Monthly fee ex VAT. */
  fee: number;
  feeNote: string;
  included: string;
  blurb: string;
  points: string[];
  /** Spend cap a new workspace starts with (docs/02 §6). */
  defaultCap?: number;
  cta: string;
  featured?: boolean;
}

export const VAT_RATE = 0.2;

export const signupPlans: SignupPlan[] = [
  {
    id: "trial",
    name: "Trial",
    fee: 0,
    feeNote: "for 30 days",
    included: "£5 of credit to spend",
    blurb: "Try Guv properly, with a real database and a real web address.",
    points: ["1 vCPU and 1 GB per app", "Up to 3 apps", "Generated web addresses only"],
    cta: "Start my trial",
  },
  {
    id: "hobby",
    name: "Hobby",
    fee: 5,
    feeNote: "a month",
    included: "£5 of usage included",
    blurb: "For side projects and AI-built apps that need a proper home.",
    points: ["Up to 8 vCPU and 8 GB per app", "2 custom domains per app", "7 days of logs"],
    defaultCap: 10,
    cta: "Choose Hobby",
  },
  {
    id: "pro",
    name: "Pro",
    fee: 20,
    feeNote: "a month",
    included: "£20 of usage included",
    blurb: "For teams and businesses shipping to customers.",
    points: ["Preview apps for every pull request", "Roles and permissions", "3 members included, then £5 each"],
    defaultCap: 50,
    cta: "Choose Pro",
    featured: true,
  },
  {
    id: "business",
    name: "Business",
    fee: 250,
    feeNote: "a month",
    included: "£250 of usage included",
    blurb: "For regulated work: care, health, legal and education.",
    points: ["Single sign-on", "DPA and DSPT evidence pack", "99.95% uptime agreement"],
    cta: "Choose Business",
  },
];
